import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import css_248z from './buttonedTabBar.styles.css.js';

/**
 * ButtonedTabs Component.
 *
 * @element buttoned-tabs
 */
let ButtonedTabs = class ButtonedTabs extends LitElement {
    constructor() {
        super(...arguments);
        this.tabs = [];
        this.loading = false;
        this.fullWidth = false;
        this.size = 'small';
    }
    handleClick(id) {
        if (id && this.tabs.length && !this.loading) {
            this.activeTab = id;
            this.dispatchEvent(new CustomEvent('tab-change', {
                detail: { activeTab: id },
                bubbles: true,
                composed: true,
            }));
        }
    }
    get computedClasses() {
        return [
            'buttoned-tab-bar',
            `--size-${this.size}`,
            this.fullWidth && '--full-width',
        ]
            .filter(Boolean)
            .join(' ');
    }
    renderTab(item) {
        const isActive = this.activeTab === item.id;
        const tabClass = [
            'buttoned-tab-bar__tab',
            isActive && 'buttoned-tab-bar__tab--active',
        ]
            .filter(Boolean)
            .join(' ');
        return html `
      <button
        class="${tabClass}"
        @click="${() => this.handleClick(item.id)}"
      >
        ${item.title}
      </button>
    `;
    }
    render() {
        return html `
      <div class="${this.computedClasses}">
        <div class="buttoned-tab-bar__tabs">
          ${this.tabs.length
            ? this.tabs.map((tab) => this.renderTab(tab))
            : null}
        </div>
      </div>
    `;
    }
};
ButtonedTabs.styles = css `
    ${unsafeCSS(css_248z)}
    :host {
      width: 100%;
    }
  `;
__decorate([
    property({ type: Array })
], ButtonedTabs.prototype, "tabs", void 0);
__decorate([
    property({ type: Object })
], ButtonedTabs.prototype, "activeTab", void 0);
__decorate([
    property({ type: Boolean })
], ButtonedTabs.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean })
], ButtonedTabs.prototype, "fullWidth", void 0);
__decorate([
    property({ type: String })
], ButtonedTabs.prototype, "size", void 0);
ButtonedTabs = __decorate([
    customElement('buttoned-tabs')
], ButtonedTabs);
var ButtonedTabs$1 = ButtonedTabs;

export { ButtonedTabs, ButtonedTabs$1 as default };
//# sourceMappingURL=buttonedTabBar.js.map
